module.exports = __webpack_public_path__ + "img/contact.pic.06b05296.jpg";